import { connect } from 'react-redux';
import { currentUserSelectors, pstnNumbersSelectors } from '@lifesize/nucleus';
import ContactDetailsBlock from 'components/Contacts/ContactDetailsBlock/ContactDetailsBlock';
import _get from 'lodash/get';

function mapStateToProps(state, ownProps) {
  const additionalNumbersURL = _get(currentUserSelectors.myInfo(state), 'additionalNumbersURL');
  const hasMeetingLink = !!_get(ownProps.contact, 'inviteURL') && !_get(ownProps.contact, 'isPersonalContact');
  const pstnNumbers = pstnNumbersSelectors.pstnNumbersWithCountryName(state);

  return {
    additionalNumbersURL,
    hasMeetingLink,
    pstnNumbers
  };
}

export default connect(mapStateToProps)(ContactDetailsBlock);
